import dashboard from './modules/dashboard';
import BasicLayout from '@/layouts/basic-layout';

import org from './modules/org';
import bpm from './modules/bpm';
import notice from './modules/notice';
import news from './modules/news';
import website from './modules/website';
import sys from './modules/sys';
import schedule from './modules/schedule';
import sclm from './modules/sclm';

/**
 * 在主框架内显示
 */

const frameIn = [
    {
        path: '/',
        name: 'home',
        redirect: {
            name: 'dashboard-console'
        },
        component: BasicLayout,
        children: [
            {
                path: 'index',
                name: 'index',
                redirect: {
                    name: 'dashboard-console'
                }
            },
            {
                path: 'log',
                name: 'log',
                meta: {
                    title: '前端日志',
                    auth: false
                },
                component: () => import('@/pages/system/log')
            },
            // 刷新页面 必须保留
            {
                path: 'refresh',
                name: 'refresh',
                hidden: true,
                component: {
                    beforeRouteEnter (to, from, next) {
                        next(instance => instance.$router.replace(from.fullPath));
                    },
                    render: h => h()
                }
            },
            // 页面重定向 必须保留
            {
                path: 'redirect/:route*',
                name: 'redirect',
                hidden: true,
                component: {
                    beforeRouteEnter (to, from, next) {
                        next(instance => instance.$router.replace(JSON.parse(from.params.route)));
                    },
                    render: h => h()
                }
            }
        ]
    },
    dashboard,
    org,
    bpm,
    notice,
    news,
    website,
    sys,
    schedule,
    sclm
];

/**
 * 在主框架之外显示
 */

const frameOut = [
    // 登录
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '$t:page.login.title'
        },
        component: () => import('@/pages/account/login')
    },
    // 注册
    {
        path: '/register',
        name: 'register',
        meta: {
            title: '$t:page.register.title'
        },
        component: () => import('@/pages/account/register')
    },
    // 注册结果
    {
        path: '/register/result',
        name: 'register-result',
        meta: {
            auth: true,
            title: '注册结果'
        },
        component: () => import('@/pages/account/register/result')
    },
    // 测试界面
    {
        path: '/test',
        name: 'test',
        meta: {
            title: '测试界面'
        },
        component: () => import('@/components/ab-cust-dialog/test.vue')
    },
    // 忘记密码
    {
        path: '/forgotpwd',
        name: 'forgotpwd',
        meta: {
            title: '$t:page.login.forgot'
        },
        component: () => import('@/pages/account/forgotpwd')
    },
    // 重置密码
    {
        path: '/pwd/reset',
        name: 'pwd-reset',
        meta: {
            title: '重置密码'
        },
        component: () => import('@/pages/account/reset')
    },
    // office在线编辑
    {
        path: '/office/online',
        name: 'officeOnline',
        meta: {
            title: '文档在线编辑预览'
        },
        component: () => import('@/pages/sclm/office/officeOnline.vue')
    },
    // 文件模板编辑
    {
        path: '/fileTemp/edit',
        name: 'fileTempEdit',
        meta: {
            title: '文件编辑预览'
        },
        component: () => import('@/pages/sclm/office/fileTempEdit.vue')
    },
    // pdf预览
    {
        path: '/pdf/pdfview',
        name: 'pdfview',
        meta: {
            title: 'pdf预览'
        },
        component: () => import('@/pages/sclm/ocr/pdfview.vue')
    },
    // pdf预览
    {
        path: '/pdf/pdfview2',
        name: 'pdfview',
        meta: {
            title: 'pdf预览'
        },
        component: () => import('@/pages/sclm/pdf/pdfView.vue')
    },
    {
        path: '/file/fileDiffResult',
        name: 'fileDiffResult',
        meta: {
            title: '文件对比',
            desc: '文件对比'
        },
        component: () => import('@/pages/sclm/ocr/fileDiffResult.vue')
    },
    // pdf批注
    {
        path: '/pdf/pdfDraw',
        name: 'pdfDraw',
        meta: {
            title: 'pdf批注'
        },
        component: () => import('@/pages/sclm/pdf/pdfDraw.vue')
    },
    {
        path: '/ocr/ocrFileDiffResult',
        name: 'ocrFileDiffResult',
        meta: {
            title: '对比结果',
            desc: '对比结果'
        },
        component: () => import('@/pages/sclm/ocr/ocrFileDiffResult.vue')
    },
    // 合同授权书
    {
        path: '/contract/authorisation',
        name: 'contractAuthorization',
        meta: {
            title: '合同授权书'
        },
        component: () => import('@/pages/sclm/contract/contractAuthorization.vue')
    },
    {
        path: '/master/sclmMDocEditHistory',
        name: 'sclmMDocEditHistory',
        meta: {
            title: '$t:menu.sclmMDocEditHistory',
            desc: '合同文档编辑记录'
        },
        component: () => import('@/pages/sclm/master/sclmMDocEditHistory.vue')
    },

    {
        path: '/signingPartyDocuments/employeeInformation',
        name: 'employeeInformation',
        meta: {
            title: '$t:menu.sclmMSupplierPartyEdit',

        },
        component: () => import('@/pages/sclm/master/employeeInformation.vue')
    },
    {
        path: '/form/form/previewTo',
        name: 'form_preview',
        meta: {
            title: '$t:menu.formPreview',
        },
        component: () => import('@/pages/bpm/form/preview.vue')
    },
    //只显示表单预览，不显示菜单
    {
        path: '/form/form/previewExterna',
        name: 'previewExterna',
        meta: {
            title: '$t:menu.formPreview',
        },
        component: () => import('@/pages/bpm/form/previewExternal.vue')   
    },
];

/**
 * 错误页面
 */

const errorPage = [
    {
        path: '/403',
        name: '403',
        meta: {
            title: '403'
        },
        component: () => import('@/pages/system/error/403')
    },
    {
        path: '/500',
        name: '500',
        meta: {
            title: '500'
        },
        component: () => import('@/pages/system/error/500')
    },
    {
        path: '*',
        name: '404',
        meta: {
            title: '404'
        },
        component: () => import('@/pages/system/error/404')
    },
];

// 导出需要显示菜单的
export const frameInRoutes = frameIn;

// 重新组织后导出
export default [
    ...frameIn,
    ...frameOut,
    ...errorPage
];
